import React from 'react';
import {Col, Row} from "react-bootstrap";
import {t} from "react-switch-lang";
import InputText from "../../../../../../components/FormFields/InputText";
import InputDate from "../../../../../../components/FormFields/inputDate/InputDate";

function ContractForm({disabled,proponentFormValues}) {
    return (
        <Row className={'pb-5'}>
            <Col className="col-6 col-xl-3">
                <label className="label w-100 mt-2">
                    <br/>
                    {t('externalization.riskProponentForm.contractNumber')}
                    <span className="optional register line-height">{t('common.optional')} </span>
                </label>
                <InputText
                    name="contractNumber"
                    type="text"
                    className="form-control input-field"
                    disabled={disabled}
                    placeholder={t('externalization.riskProponentForm.placeholder.contractNumber')}
                    id="contractNumber"
                    defaultValue={proponentFormValues?.contractNumber}
                />
            </Col>
            <Col className="col-6 col-xl-3">
                <label className="label w-100 mt-2">
                    <br/>
                    {t('externalization.riskProponentForm.contractTitle')}
                    <span className="optional register line-height">{t('common.optional')} </span>
                </label>
                <InputText
                    type="text"
                    name="contractTitle"
                    className="form-control input-field"
                    disabled={disabled}
                    defaultValue={proponentFormValues?.contractTitle}
                    placeholder={t('externalization.riskProponentForm.placeholder.contractTitle')}
                    id="contractTitle"
                />
            </Col>
            <Col className="col-6 col-xl-3">
                <label className="label w-100 mt-2">
                    <br/>
                    {t('externalization.riskProponentForm.contractValidity')}
                    <span className="optional register line-height">{t('common.optional')} </span>
                </label>
                <InputDate
                    name="contractStartDate"
                    className={'date-input'}
                    disabled={disabled}
                    placeholder={t('externalization.riskProponentForm.placeholder.contractValidity')}
                />
            </Col>
            <Col className="col-6 col-xl-3">
                <label className="label w-100 mt-2">
                    <br/>
                    {t('externalization.riskProponentForm.contractDuration')}
                    <span className="optional register line-height">{t('common.optional')} </span>
                </label>
                <InputDate
                    name="contractEndDate"
                    className={'date-input'}
                    disabled={disabled}

                    placeholder={t('externalization.riskProponentForm.placeholder.contractDuration')}
                />
            </Col>
        </Row>
    );
}

export default ContractForm;